<template>
 <div class="ViewContent">
     <div class="introduce"  v-for="(it,index) in list"
      :key="index" :style="{'height':it.height ,'background-color':it.color?it.color:'transparent'}">
     <div class="introduce-content" :class="[it.type==='left'?'leftActive':'rightActive']">
        <p class="introduce-content-title" :style="{'color':it.fontColor?it.fontColor:'#fff'}">{{it.title}}</p>
        <p :style="{'width':it.width}">{{it.content}}</p>
      </div>
      <div  :class="[it.type==='left'?'rightActiveImg':'leftActiveImg','introduce-img']">
        <img :src="it.img" alt="">
      </div>
  </div>
 </div>
</template>

<script>
export default {
props:{
    list:{
        type:Array
    }
}
}
</script>

<style scoped>
.leftActiveImg{
top: 47px;
left: 360px;
}
.rightActiveImg{
top: 47px;
right: 360px;
}
.introduce-img{
    width: 552px;
    height: 320px;
    object-fit: cover;
    position: absolute;
  
}
.leftActive{
padding-left:360px;
top: 0;
left: 0;
}
.rightActive{
     padding-left: 100px;

    top: 0;
right: 0;
}
.introduce{

  min-width: 1920px;

  position: relative;
  background-size: cover;
  }
  .introduce-content{
 
    width: 50%;
    font-family: Regular;
font-weight: 300;
font-size: 20px;
color: #838690;
line-height: 28px;
display: flex;
flex-direction: column;
justify-content: center;
height: 100%;
position: absolute;

  }
  .introduce-content-title{
    font-family:Medium;
font-weight: 500;
font-size: 30px;
color: #FFFFFF;
line-height: 42px;
width: 120px;
margin-bottom: 20px;

  }
   .introduce-content p{
    width: 500px;
   }
</style>